import gql from 'graphql-tag';

export const AddressFields = gql`
  fragment AddressFields on OdProtosCasaData_Address {
    uuid
    street
    city
    state
    postalCode
    unitType
    unitNumber
  }
`;
